import React, { useEffect, useState } from "react";
import SignupModal from "./SignupModal";
import styles from "./Styles/RiderLoginForm.module.css";

import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { usePostRequestMutation } from "../../store/services/users";
import classes from "./Styles/Section1styles.module.css";
import Swal from "sweetalert2";

const RiderLoginForm: React.FC = () => {
  const [Register] = usePostRequestMutation();
  const navigate = useNavigate();
  const [code, setCode] = useState<string>("");
  const [isOpen, setIsOpen] = useState(false);

  const [enteredData, setEnteredData] = useState({
    email: "",
    password: "",
  });

  const [showVerifyForm, setShowVerifyForm] = useState<boolean>(false);

  // Separate loading flags — Register is one shared mutation hook used for
  // three different calls (login, resend code, verify), so a single
  // isLoading from the hook would light up all three buttons at once.
  const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false);
  const [isVerifying, setIsVerifying] = useState<boolean>(false);
  const [isResending, setIsResending] = useState<boolean>(false);

  const toggleVerificationForm = () => {
    setShowVerifyForm(!showVerifyForm);
  };

  const onChangeHandler = (element: React.ChangeEvent<HTMLInputElement>) => {
    setEnteredData((prevState) => ({
      ...prevState,
      [element.target.name]: element.target.value,
    }));
  };

  const onSubmitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isLoggingIn) return;

    setIsLoggingIn(true);

    Register({
      url: "/login",
      body: { ...enteredData },
    })
      .unwrap()
      .then(() => {
        onRequestCodeHandler();
        toggleVerificationForm();
      })
      .catch((error) => {
        console.log("Error===>>>", error);
        Swal.fire("Error!", error.data.error, "error");
      })
      .finally(() => {
        setIsLoggingIn(false);
      });
  };

  // Re generate code
  const onRequestCodeHandler = () => {
    if (isResending) return;
    setIsResending(true);

    Register({
      url: "/generate-confirmation-code",
      body: {
        emailType: "verify-email",
        email: enteredData.email,
      },
    })
      .unwrap()
      .then(() => {})
      .catch((error) => {
        console.log("Error", error.data);
        Swal.fire("Error!", error.data.error, "error");
      })
      .finally(() => {
        setIsResending(false);
      });
  };

  const onVerifyhandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isVerifying) return;

    setIsVerifying(true);

    Register({
      url: "/acccount-verification-verify-code",
      body: {
        email: enteredData.email,
        code: code,
      },
    })
      .unwrap()
      .then((data) => {
        localStorage.setItem("token", data.user.token);
        navigate("/rider-application");
      })
      .catch((error) => {
        console.log("Error", error);
        Swal.fire("Error!", error.data.error, "error");
      })
      .finally(() => {
        setIsVerifying(false);
      });
  };

  const isTokenExpired = (token: any) => {
    if (!token) return;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return Math.floor(Date.now() / 1000) >= payload.exp;
  };

  const token = localStorage.getItem("token");
  const expired = isTokenExpired(token);

  useEffect(() => {
    if (expired || !token || token.length < 1) {
      //   navigate("/rider");
    } else {
      navigate("/rider-application");
    }
  }, [expired]);

  return (
    <>
      <div className={styles.container}>
        {/* Left Side - Illustration */}
        <div className={styles.left}></div>

        {/* Right Side - Form */}
        <div className={styles.right}>
          <div className={styles.header}>
            <p className={styles.signUpText}>
              Don’t have an account?   {/* Sign Up Button */}
      <a className={styles.signupBtn} onClick={() => setIsOpen(true)}>
        Sign Up
      </a>
            </p>
          </div>

          <h1 className={styles.title}>Sign in</h1>
          <p className={styles.subTitle}>Sign in with Open account</p>

          <form className={styles.form} onSubmit={onSubmitHandler}>
            <input
              type="email"
              placeholder="Email address"
              className={styles.input}
              onChange={onChangeHandler}
              name="email"
              disabled={isLoggingIn}
              required
            />
            <input
              type="password"
              placeholder="Password"
              className={styles.input}
              name="password"
              onChange={onChangeHandler}
              disabled={isLoggingIn}
              required
            />

            <button
              className={styles.submitBtn}
              type="submit"
              disabled={isLoggingIn}
            >
              {isLoggingIn && <span className={styles.spinner} />}
              {isLoggingIn ? "Signing in..." : "Start riding"}
            </button>
          </form>
        </div>
      </div>

      {showVerifyForm && (
        <div className={classes.rider_login_wrapper}>
          <div className={classes.login_wrapper}>
            <div>
              <div className={classes.row}>
                <h1>Verify Account</h1>
                <FaTimes size={25} onClick={toggleVerificationForm} />
              </div>
              <p>Please check your email, a verification code was sent.</p>
              <form onSubmit={onVerifyhandler}>
                <input
                  type="text"
                  placeholder="Enter code"
                  value={code}
                  onChange={(el: React.ChangeEvent<HTMLInputElement>) =>
                    setCode(el.target.value)
                  }
                  name="code"
                  disabled={isVerifying}
                  required
                />

                <br />
                <p
                  className={`${classes.request_code_style} ${
                    isResending ? classes.disabled : ""
                  }`}
                  onClick={isResending ? undefined : onRequestCodeHandler}
                >
                  {isResending ? "Sending code..." : "Didn't get the code?"}
                </p>

                <button
                  type="submit"
                  className={classes.verifyBtn}
                  disabled={isVerifying}
                >
                  {isVerifying && <span className={classes.spinnerDark} />}
                  {isVerifying ? "Verifying..." : "Verify"}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    {isOpen && <SignupModal onCloseHandler={() => setIsOpen(false)} />}
    </>

  );
};

export default RiderLoginForm;